// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

export default css`
  &.filter-fit-main {
    .slick-slider {
      text-align: left;
    }
    .slick-track {
      display: flex;
      margin: 0 !important;
    }
    .slick-slide {
      display: flex;
      height: auto;
      width: fit-content !important;
    }
    .slick-prev {
      left: -20px !important;
      top: 52% !important;
      height: 14px;
      width: 35px;
      background-color: unset;
      border-radius: unset;
      padding: unset;
      box-shadow: unset;
      background-size: unset !important;
    }
    .slick-next {
      right: -25px !important;
      top: 52% !important;
      height: 14px;
      width: 35px;
      background-color: unset;
      border-radius: unset;
      padding: unset;
      box-shadow: unset;
      background-size: unset !important;
    }
    .tcp_carousel_wrapper .slick-slider.tcp_carousel.slick-initialized {
      background-color: unset;
      margin: 0px;
      border: none;
    }
    .slick-initialized .slick-slide {
      padding-right: 0px;
    }
    .tcp_carousel_wrapper .slick-slide div {
      padding: 2px !important;
    }
  }
  .customer-rating-radio-buttons {
    display: flex;
  }
  .pill-click {
    ${(props) =>
      props.ratingsFilter
        ? `
    display: flex;`
        : ''}
  }
  .size-and-fit-detail-item {
    padding: 0px;
    width: 100%;
    margin-top: ${(props) => (props.ratingsFilter ? '10px' : '')};
    @media ${(props) => props.theme.mediaQuery.medium} {
      /* margin: ${(props) => props.theme.spacing.ELEM_SPACING.XXS}; */
      /* width: 182px; */
      width: 95%;
    }
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      overflow-x: auto;
      overflow-y: hidden;
      ${(props) =>
        !props.ratingsFilter
          ? `
      display: flex;
      flex-wrap: nowrap;
      `
          : ''}
    }
    cursor: pointer;

    .input-radio-title {
      border: 1px solid ${(props) => props.theme.colorPalette.gray[900]};
      display: flex;
      flex: 1;
      justify-content: center;
      align-items: center;
      text-transform: uppercase;
      color: ${(props) => props.theme.colorPalette.gray[900]};
      border-radius: 6px;
      text-align: center;
      width: auto;
      min-width: 60px;
      height: 16px;
      letter-spacing: 0.42px;
      padding: 2px;
      font-family: 'Nunito';
      margin: 0;
      font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy2}px;
      ${(props) =>
        !props.ratingsFilter
          ? `
          border: 1px solid ${props.theme.colorPalette.gray[900]};
          border-radius: 6px;
          width: auto;
          min-width: 60px;
          height: 16px;
          outline: none;
          `
          : ''}
    }

    .input-radio-title:hover {
      cursor: pointer;
      ${(props) =>
        !props.ratingsFilter
          ? `
          border-radius: 6px;
          border: solid 1px ${props.theme.colors.PRIMARY.DARK};
          background-color: ${props.theme.colors.PRIMARY.PALEGRAY};
          `
          : ''}
    }
    &.item-disabled-option {
      outline: none;
    }
    &.item-disabled-option .input-radio-title {
      ${(props) =>
        !props.newQVDesign
          ? `color: ${props.theme.colors.PRIMARY.LIGHTERGRAY}; cursor: initial; border: solid 1px ${props.theme.colors.PRIMARY.LIGHTERGRAY}`
          : ''}
    }

    .input-radio-icon-unchecked,
    .input-radio-icon-checked {
      width: auto;
      height: auto;
      top: auto;
      position: absolute;
      vertical-align: middle;

      input {
        -webkit-appearance: none;
        display: none;
      }

      &:before,
      &:after {
        display: none;
      }
    }

    .input-radio-icon-checked + .input-radio-title {
      background: ${(props) => (props.ratingsFilter ? props.theme.colors.BLACK : '#f3f3f3')};
      color: ${(props) => props.theme.colors.BLACK};
      ${(props) =>
        props.newQVDesign
          ? `border: solid 3px ${props.theme.brandSpecificStyles.STROKE_COLOR_BORDER_COLOR};`
          : `border: solid 1px ${props.theme.colors.PRIMARY.DARK};`}
      outline: ${(props) => (props.newQVDesign ? 'solid 3px transparent' : '')};
      font-size: ${(props) => props.theme.typography.fontSizes.fs12};
      font-family: ${(props) => props.theme.typography.fonts.secondary};
      font-weight: ${(props) =>
        props.newQVDesign ? props.theme.fonts.fontWeight.bold : props.theme.fonts.fontWeight.black};
      line-height: ${(props) => props.theme.fonts.lineHeight.normal};
      border-radius: 6px;
      box-shadow: ${(props) =>
        props.newQVDesign ? '0 5px 12px 0 rgba(0, 0, 0, 0.12)' : 'inherit'};
      ${(props) =>
        props.ratingsFilter
          ? `outline:solid 1px black;border: solid 4px ${props.theme.colors.WHITE};border-radius: 10px;          `
          : ''}
    }
    .pill-click {
      background-color: #fff;
      padding: 5px;
      @media ${(props) => props.theme.mediaQuery.desktop} {
        padding: 1px;
      }
      z-index: ${(props) => props.theme.zindex.zEnlargedImage};
    }

    .fit-pill {
      @media ${(props) => props.theme.mediaQuery.mediumMax} {
        padding: 4px;
      }
    }
  }
  .size-and-fit-detail-item::-webkit-scrollbar {
    display: none;
  }
`;
